
import UIkit from 'uikit'
import { Component, Vue, Watch } from 'vue-property-decorator'

import VueRecaptcha from 'vue-recaptcha'

import BacHeader from '../templates/BacHeader.vue'
import RegisterAddress from '../components/register/RegisterAddress.vue'
import RegisterBaseData from '../components/register/RegisterBaseData.vue'

import { User } from '@/lib/models/User'
import { Http } from '@/lib/utils/Http'
import { RegisterUserDTO } from '../lib/modules/auth/dtos/RegisterUserDTO'

@Component({
  components: {
    BacHeader,
    VueRecaptcha,
    RegisterAddress,
    RegisterBaseData
  }
})
export default class Register extends Vue {
  user: RegisterUserDTO = new RegisterUserDTO()

  mounted () {
    this.user = new RegisterUserDTO()
  }

  onCaptchaVerify (token: string) {
    this.user.captchaToken = token
  }

  async register (e: Event) {
    e.preventDefault()
    if (!this.validateForm()) {
      return
    }

    this.user.email = this.user.email.trim()

    const res = await Http.request('/api/user/register', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(this.user)
    })
    if (res.status > 200) {
      const resJson = await res.json()

      if (resJson.error === 'invalid-captcha') {
        UIkit.notification({
          message:
            'Etwas hat mit der Roboter-Überprüfung nicht gestimmt, bitte lade die Seite neu und versuche es erneut',
          status: 'success',
          timeout: 5000,
          pos: 'bottom-center'
        });
        (this.$refs.recaptchaElement as any).reset()
        return
      } else if (resJson.error === 'user-already-exists') {
        UIkit.notification({
          message:
            'Ein User mit dieser Mailadresse existiert bereits. Bitte verwende die Passwort vergessen Funktion solltest du noch kein Passwort haben!',
          status: 'success',
          timeout: 5000,
          pos: 'bottom-center'
        });
        (this.$refs.recaptchaElement as any).reset()
        return
      } else if (resJson.error === 'invalid-email') {
        UIkit.notification({
          message: 'Bitte gib eine korrekte E-Mail Adresse an',
          status: 'success',
          timeout: 5000,
          pos: 'bottom-center'
        });
        (this.$refs.recaptchaElement as any).reset()
      } else {
        UIkit.notification({
          message:
            'Ein unbekannter fehler ist aufgetreten, bite lade die Seite neu und versuche es erneut',
          status: 'success',
          timeout: 5000,
          pos: 'bottom-center'
        });
        (this.$refs.recaptchaElement as any).reset()
        return
      }
    }

    // successfully created, now login
    const resLogin = await Http.request('/api/auth/login', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        username: this.user.email,
        password: this.user.password
      })
    })

    const loginData = await resLogin.json()

    if (loginData) {
      if (process.env.NODE_ENV === 'development') {
        (this as any).$cookie.set('auth', loginData.cookie)
      } else {
        (this as any).$cookie.set('auth', loginData.cookie, {
          domain: 'https://www.backroadclub.com'
        })
      }
      window.parent.location.replace('/teamarea/your-rallies')
    }
  }

  validateForm () {
    const error = this.user.validate()

    if (error) {
      UIkit.notification({
        message: error,
        status: 'success',
        timeout: 5000,
        pos: 'bottom-center'
      })
      return false
    }

    return true
  }
}
